import { useState } from 'react';

const Table = ({ columns = [], data = [], actions, loading, error, emptyMessage = 'No data', onRowClick, selectedKey: controlledSelectedKey }) => {
  const [internalSelectedKey, setInternalSelectedKey] = useState(null);
  const getRowBackground = (index) => (index % 2 === 0 ? 'bg-white dark:bg-dark' : 'bg-[#FBFCFE] dark:bg-dark');
  const colSpanCount = (columns?.length || 0) + (actions ? 1 : 0);

  const renderTableBody = () => {
    if (loading) {
      return (
        <tr>
          <td colSpan={colSpanCount} className="px-4 py-3 text-xs text-text-100">
            Loading…
          </td>
        </tr>
      );
    }

    if (error) {
      return (
        <tr>
          <td colSpan={colSpanCount} className="px-4 py-3 text-xs text-red-600">
            {String(error)}
          </td>
        </tr>
      );
    }

    if (data.length === 0) {
      return (
        <tr>
          <td colSpan={colSpanCount} className="px-4 py-3 text-xs text-text-100">
            {emptyMessage}
          </td>
        </tr>
      );
    }

    return data.map((row, index) => {
      const rowKey = row.documentId || row.id || index;
      const isSelected = rowKey === (controlledSelectedKey ?? internalSelectedKey);
      return (
        <tr
          key={rowKey}
          className={`${getRowBackground(index)} ${isSelected ? '!bg-[#E47F451A] dark:!bg-[#E47F4533]' : ''} hover:!bg-[#E47F451A] dark:hover:!bg-[#E47F4533] ${onRowClick ? 'cursor-pointer' : ''}`}
          onClick={() => {
            setInternalSelectedKey(rowKey);
            onRowClick?.(row);
          }}
        >
          {columns.map((col) => (
            <td
              key={`${rowKey}-${col.key}`}
              className={`py-[15px] px-2 text-text-100 dark:text-white text-xs font-medium leading-4 ${col.className || ''}`}
              style={columns.indexOf(col) === 0 ? { color: '#225874' } : undefined}
            >
              {col.render ? col.render(row) : row[col.key]}
            </td>
          ))}
          {actions && (
            <td className="py-[15px] px-1">
              <div className="flex justify-center items-center">
                <span className="dark:fill-white">{actions(row)}</span>
              </div>
            </td>
          )}
        </tr>
      );
    });
  };

  return (
    <div className="bg-light dark:bg-dark overflow-auto rounded-2xl  pt-2">
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white dark:bg-dark">
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col.key} className={`py-[11px] px-2 border-b border-[#E9E9E9] dark:border-[#181818] text-left text-[#A4A4A4] text-xs font-normal leading-4 ${col.width || ''}`}>
                  {col.label}
                </th>
              ))}
              {actions && <th className="py-[11px] px-1 border-b border-[#E9E9E9] dark:border-[#181818] text-center text-[#A4A4A4] text-xs font-normal leading-4 w-1/5">Action</th>}
            </tr>
          </thead>
          <tbody>{renderTableBody()}</tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
